(function () {
	var STORAGE_KEY = 'clarabelle_guest_prompt_dismissed';
	var DELAY_MS = 3000;

	var root = document.getElementById('guestPrompt');
	if (!root) return;

	var bodyLoggedIn =
		document.body.getAttribute('data-customer-logged-in') === 'true';
	var hasLogoutLink = !!document.querySelector(
		'.accountLinks .accountLink.logout'
	);
	var hasAccountLink = !!document.querySelector(
		'.accountLinks .accountLink[href*="/account"]'
	);
	if (bodyLoggedIn || hasLogoutLink || hasAccountLink) return;
	if (sessionStorage.getItem(STORAGE_KEY) === '1') return;

	var closeTriggers = root.querySelectorAll('[data-guest-prompt-close]');
	var previouslyFocused = null;

	function open() {
		root.hidden = false;
		root.classList.add('guestPrompt--open');
		root.setAttribute('aria-hidden', 'false');
		document.body.classList.add('guestPrompt-active');
		previouslyFocused = document.activeElement;
		var closeBtn = root.querySelector('.guestPrompt__close');
		if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
	}

	function close() {
		root.classList.remove('guestPrompt--open');
		root.setAttribute('aria-hidden', 'true');
		root.hidden = true;
		document.body.classList.remove('guestPrompt-active');
		sessionStorage.setItem(STORAGE_KEY, '1');
		if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
			previouslyFocused.focus();
		}
		previouslyFocused = null;
	}

	setTimeout(function () {
		if (sessionStorage.getItem(STORAGE_KEY) === '1') return;
		open();
	}, DELAY_MS);

	closeTriggers.forEach(function (el) {
		el.addEventListener('click', function (e) {
			e.preventDefault();
			close();
		});
	});

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape' && root.classList.contains('guestPrompt--open')) {
			e.preventDefault();
			close();
		}
	});
})();
